import { jsx as t } from "react/jsx-runtime";
import o from "./roche-empty-state.module.scss.js";
const l = ({ message: e, slot: r }) => (
  // The alert role implies aria-live assertive and aria-atomic true, and screen readers
  // announce its content when the element is inserted.
  /* @__PURE__ */ t("div", { slot: r, className: o["empty-state"], role: "alert", children: /* @__PURE__ */ t("p", { children: e }) })
);
export {
  l as RocheUIEmptyState
};
